import React from 'react';

function ProjectCard({ project, index }) {
  // Alternate between right and left alignment
  const alignment = index % 2 === 0 ? 'md:justify-end' : 'md:justify-start';
  
  // Handle placeholder images
  const imageContent = project.image ? (
    <img src={project.image} alt={project.title} className="w-full h-48 object-cover mb-4 rounded-t-lg" />
  ) : (
    <div className="w-full h-48 bg-[#1F2329] mb-4 flex items-center justify-center rounded-t-lg border border-[#2A2E35]">
      <span className="text-gray-400 text-sm">Project Image</span>
    </div>
  );

  return (
    <div className={`md:flex ${alignment} w-full md:w-1/2 px-2 md:px-4 mb-6 md:mb-8`}>
      <article className="bg-[#1F2329] p-3 md:p-4 rounded-lg shadow-lg mb-4 border border-[#2A2E35] hover:border-[#FF6C4D] transition-colors h-full flex flex-col">
        {imageContent}
        <h3 className="text-lg md:text-xl font-bold text-white mb-2 border-b-2 border-[#FF6C4D] pb-1 inline-block">{project.title}</h3>
        <p className="text-sm md:text-base text-gray-300 mt-2 mb-4">{project.description}</p>
        {project.impact && (
          <p className="text-sm text-[#FFB6A8] mb-4">{project.impact}</p>
        )}
        <div className="flex flex-wrap gap-2">
          {project.technologies.map((tech, techIndex) => (
            <span key={techIndex} className="bg-[#1F2329] text-xs text-gray-300 px-2 py-1 rounded-full border border-[#2A2E35]">
              {tech}
            </span>
          ))}
        </div>
        {(project.link || project.repo) && (
          <div className="mt-5 flex gap-3">
            {project.link && (
              <a
                href={project.link}
                target="_blank"
                rel="noopener noreferrer"
                className="text-sm bg-[#FF6C4D] text-white px-3 py-2 rounded-md hover:bg-[#FF8C6D] transition-colors"
              >
                View Project
              </a>
            )}
            {project.repo && (
              <a
                href={project.repo}
                target="_blank"
                rel="noopener noreferrer"
                className="text-sm border border-[#FF6C4D] text-[#FF6C4D] px-3 py-2 rounded-md hover:bg-[#FF6C4D] hover:text-white transition-colors"
              >
                Source Code
              </a>
            )}
          </div>
        )}
      </article>
    </div>
  );
}

export default ProjectCard;
